/**
 * Entry point for the React home search component
 */
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import SearchSuggest from "./components/App/SearchSuggest";

const rootNode = document.getElementById("ns-home-search");

ReactDOM.render(<SearchSuggest />, rootNode);
